import type { BookableAssetDetailDto, BookableAssetDto } from "@/api/types";

export function getIsBookableAssetSharable(asset: BookableAssetDto | BookableAssetDetailDto): boolean {
  return Boolean(asset.publishedAt);
}
